import script from "./UnauthorizedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&setup=true&lang=js"

import "./UnauthorizedPage.vue?vue&type=style&index=0&id=1f93213e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f93213e"]])

export default __exports__